export default __webpack_public_path__ + "static/media/block1_button.a7a4b71f.svg";